<template>
  <base-card>
    <v-card-text>
      <div class="d-flex flex-column align-center justify-center text-center py-6">
        <h3 class="mb-8">Envío de Facturas Electrónicas</h3>

        <v-select
          v-model="selectedCompany"
          :items="filteredCompanies"
          item-text="displayText"
          label="Selecciona una compañía"
          prepend-inner-icon="mdi-domain"
          return-object
          dense
          solo
          @change="fetchToken"
        >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="search"
                  placeholder="Buscar compañía"
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  dense
                  class="mx-4"
                />
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>



        <div v-if="loadingToken"><em>Obteniendo token...</em></div>
      </div>

      <div class="d-flex flex-column align-center justify-center text-center py-6">
        <div v-if="token" class="upload-section">
          <v-file-input
            class="mb-6"
            v-model="files"
            :counter="files.length + ' archivos seleccionados'"
            accept=".xml"
            chips
            outlined
            full-width
            label="Selecciona archivos XML"
            multiple
            show-size
            @change="handleFiles"
          ></v-file-input>

          <v-btn
            :disabled="loading || files.length === 0"
            :loading="loading"
            class="ma-2"
            style="background-color: rgb(204 33 40); color: white !important;"
            @click="uploadFiles"
          >
            Enviar XMLs
          </v-btn>
          <v-btn
            :disabled="loading && files.length === 0"
            class="ma-2"
            color="gray"
            @click="clearFields"
          >
            Limpiar
          </v-btn>
        </div>

        <v-progress-linear
          v-if="loading"
          class="my-4"
          color="primary"
          indeterminate
        ></v-progress-linear>

        <v-alert
          v-if="alerta.mostrar"
          :type="alerta.tipo"
          dismissible
          @input="alerta.mostrar = false"
          class="my-4"
        >
          {{ alerta.mensaje }}
        </v-alert>

        <!-- Modal mejorado -->
        <v-dialog v-model="showModal" max-width="1200px"  persistent>
          <v-card>
            <v-card-title class="headline">
              Resultados del envío
              <v-spacer></v-spacer>
              <v-btn icon @click="showModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-simple-table dense>
                <thead>
                <tr>
                  <th>Archivo XML</th>
                  <th>Estado Envio</th>
                  <th>Estado Fiscalización</th>
                  <th>Mensaje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="r in resultados" :key="r.ConsecutivoDB">
                  <td>{{ r.NameXML }}</td>
                  <td>
                    <v-chip
                      :color="r.status === 'success' ? 'green' : 'red'"
                      text-color="white"
                      small
                    >
                      {{ r.status }}
                    </v-chip>
                  </td>
                  <td v-if="r.status === 'error'">
                    <v-chip
                      :color="'red'"
                      text-color="white"
                      small
                    >
                      {{ r.status }}
                    </v-chip>
                  </td>

                  <td v-if="r.status === 'success'">
                    <v-chip
                      :color="r.response.respuesta.error === false ? 'green' : 'red'"
                      text-color="white"
                      small
                    >
                      {{ r.response.respuesta.error === true ? 'Error' : 'OK' }}
                    </v-chip>
                  </td>
                  <td v-if="r.status === 'error'">
                    {{ r.mensaje  }}
                  </td>
                  <td v-if="r.status === 'success'">
                      {{ r.response.respuesta.Mensaje }}
                  </td>


                </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>


          </v-card>
        </v-dialog>

      </div>
    </v-card-text>
  </base-card>
</template>

<script>
import axios from 'axios';
import { environment } from "@/data/environment";

export default {
  data() {
    return {
      companias: [],
      selectedCompany: null,
      token: null,
      search: '',
      files: [],
      resultados: [],
      showModal: false,
      loading: false,
      loadingToken: false,
      alerta: {
        mostrar: false,
        mensaje: '',
        tipo: 'error'
      }
    };
  },
  computed: {
    filteredCompanies() {
      const query = this.search.toLowerCase();
      return this.companias.filter(c => c.displayText.toLowerCase().includes(query));
    }
  },
  mounted() {
    this.fetchCompanies();
  },
  methods: {
    async fetchCompanies() {
      try {
        const res = await axios.get(environment.HIOPOSWEBSERVICES + '/api/getClients');
        const data = res.data;
        this.companias = data.Mensaje.map(compania => ({
          ...compania,
          displayText: `${compania.IdCompania} - ${compania.NombreCompania}`
        }));
      } catch (e) {
        alert('Error al cargar compañías');
        console.error(e);
      }
    },

    async fetchToken() {
      if (!this.selectedCompany) return;

      this.token = null;
      this.loadingToken = true;

      try {
        const formData = new FormData();
        formData.append('TokenEnterprise', this.selectedCompany.TokenEnterprise);
        formData.append('TokenPassword', this.selectedCompany.TokenPassword);

        const response = await axios.post(
          environment.HIOPOSWEBSERVICES + '/api/login',
          formData
        );

        this.token = response.data.token;
      } catch (e) {
        alert('Error al obtener token');
        console.error(e);
      } finally {
        this.loadingToken = false;
      }
    },

    handleFiles() {
      const xmlFiles = this.files.filter(file => file.name.endsWith('.xml'));

      if (xmlFiles.length > 50) {
        this.alerta.mostrar = true;
        this.alerta.mensaje = 'Solo puedes seleccionar hasta 50 archivos XML.';
        this.files = xmlFiles.slice(0, 50);
        setTimeout(() => {
          this.alerta.mostrar = false;
        }, 3000);
      } else {
        this.files = xmlFiles;
      }
    },

    clearFields() {
      this.selectedCompany = null;
      this.search = '';
      this.files = [];
      this.token = null;
      this.resultados = [];
      this.showModal = false;
    },

    async uploadFiles() {
      if (!this.token || this.files.length === 0) return;

      this.loading = true;
      this.resultados = [];

      try {
        const xmlPayload = await Promise.all(
          this.files.map(async (file) => {
            const content = await file.text();
            return {
              SaleXML: content,
              ConsecutivoDB: '1',
              NameXML: file.name.replace(/\.xml$/i, ''),
              OrigenTrans: 'REPORTE_HIOPOS',
            };
          })
        );

        const response = await axios.post(
          environment.HIOPOSWEBSERVICES + '/api/enviarMultipleFE',
          { facturas: xmlPayload },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${this.token}`
            }
          }
        );

        this.resultados = response.data.resultados || response.data;
        this.showModal = true;
      } catch (e) {
        alert('Error al enviar archivos');
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}

.modal {
  background: white;
  padding: 1rem;
  border-radius: 10px;
  width: 400px;
  margin: 100px auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
</style>
